import * as browser from '../env/browser';
import createMemoryStorage from './memory-storage';

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
  key(index: number): string | null;
  clear(): void;
  readonly length: number;
}

export const namespaceStorage =
  (namespace: string) =>
  (storage: StorageLike): StorageLike => {
    const ns = (key: string) => `${namespace}:${key}`;

    return {
      getItem(key: string): string | null {
        return storage.getItem(ns(key));
      },
      setItem(key: string, value: string): void {
        storage.setItem(ns(key), value);
      },
      removeItem(key: string): void {
        storage.removeItem(ns(key));
      },
      // TODO: adapt for namespace usage — returns keys from full storage, not just namespaced
      key(index: number): string | null {
        return storage.key(index);
      },
      // TODO: clears entire storage, not just namespaced keys
      clear(): void {
        storage.clear();
      },
      // TODO: includes non-namespaced entries
      get length(): number {
        return storage.length;
      },
    };
  };

const appShellStorageFrom = namespaceStorage('app-shell');

export const localStorage = appShellStorageFrom(browser.localStorage);
export const sessionStorage = appShellStorageFrom(browser.sessionStorage);
export const memoryStorage = appShellStorageFrom(createMemoryStorage());
